import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { UtilsService } from "../../../../utils/utils.service";
import { CartService } from "../../../services/cart.service";
import { Router } from "@angular/router";

interface CartProduct {
  id: number;
  title: string;
  price: number;
  tax: number;
  absorbs_platform_fee?: boolean;
  absorbs_processing_fee?: boolean;
  consumption?: number;
  quantity: number;
  ticket_id: number;
  event_id: number;
}

@Component({
  selector: "app-cart-items",
  imports: [CommonModule, ButtonComponent],
  templateUrl: "./cart-items.component.html",
  styleUrl: "./cart-items.component.scss",
})
export class CartItemsComponent {
  @Input() cartProducts: CartProduct[] = [];

  constructor(
    private utilsService: UtilsService,
    private cartService: CartService,
    private readonly router: Router,
  ) {}

  formataValorEmReais(valor: number | string): string {
    return this.utilsService.formataValorEmReais(valor);
  }

  increaseQuantity(item: CartProduct): void {
    const requestBody = {
      ticket_id: Number(item.ticket_id),
      quantity: Number(item.quantity + 1),
    };

    this.cartService.addItem(requestBody).subscribe({
      next: (_response) => {
        this.removeProduct(item);
      },
      error: (error) => {
        console.error("Erro ao adicionar produto no carrinho:", error);
      },
    });
  }

  decreaseQuantity(item: CartProduct): void {
    if (item.quantity > 1) {
      const requestBody = {
        ticket_id: Number(item.ticket_id),
        quantity: Number(item.quantity - 1),
      };

      this.cartService.addItem(requestBody).subscribe({
        next: (response) => {
          console.log("RESPONSE API", response);
          this.removeProduct(item);
        },
        error: (error) => {
          console.error("Erro ao adicionar produto no carrinho:", error);
        },
      });
    }
  }

  removeProduct(item: CartProduct): void {
    this.cartService.removeItem(item.id).subscribe({
      next: (response) => {
        if (this.cartProducts.length == 1) {
          this.router.navigate([`/event/${item.event_id}`]);
        } else {
          window.location.reload();
        }
      },
      error: (error) => {
        console.error("Erro ao carregar o carrinho:", error);
      },
    });
  }
}
